module.exports = __webpack_public_path__ + "static/img/intro_logo.8c31cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro_logo.png
// module id = sNFq
// module chunks = 0